<template>
  <MatrizRfmFaixasTable
    dimensao="monetario"
    titulo="Valor Monetário (M)"
    descricao="Considera o total faturado pelo cliente dentro do período analisado. Quanto maior o valor, maior a pontuação."
    cardId="card-configuracao-valor-monetario"
    rotuloDe="De (R$)"
    rotuloAte="Até (R$)"
    placeholder="Ex.: 4999,99"
    step="0.01"
    :faixas="faixas"
    :erros="erros"
    :classificacoes="classificacoes"
    :formatador="formatarMoeda"
    :regraFormatador="regra"
    @alterar="payload => $emit('alterar', payload)"
    @restaurar="$emit('restaurar')"
  />
</template>

<script>
import MatrizRfmFaixasTable from "./MatrizRfmFaixasTable";
import { formatarMoeda } from "@/utils/rfm-faixas";

export default {
  name: "MatrizRfmMonetario",
  components: { MatrizRfmFaixasTable },
  props: {
    faixas: { type: Array, required: true },
    erros: { type: Array, default: () => [] }
  },
  data: () => ({
    classificacoes: {
      5: "Altíssimo valor",
      4: "Alto valor",
      3: "Médio valor",
      2: "Baixo valor",
      1: "Valor de entrada"
    }
  }),
  methods: {
    formatarMoeda,
    regra(faixa) {
      if (faixa.semLimite) {
        return faixa.de === null ? "-" : `${formatarMoeda(faixa.de)} ou mais`;
      }
      if (faixa.ate === null) return "-";
      return `${formatarMoeda(faixa.de)} até ${formatarMoeda(faixa.ate)}`;
    }
  }
};
</script>
